module.exports = __webpack_public_path__ + "static/media/matchingicon.c5380549.svg";